<span class="ab-occurrences"
  >{{ total
  }}<span class="annotation" *ngIf="deployAt">
    ({{ sinceDeploy }} since
    <a
      uiSref="deploys-show"
      [uiParams]="{ projectId: group.projectId, deployId: group.lastDeployId }"
    >
      <ab-timestamp
        class="ab-timestamp"
        [time]="deployAt"
        [label]="'last deploy'"
        [placement]="'right auto'"
      ></ab-timestamp></a
    >)</span
  ></span
>
